export default "__VITE_ASSET__d6fc91e2__"